import React from "react";
import "./Tickets.css";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

function TicketsGrid({ tickets }) {
  TicketsGrid.propTypes = {
    tickets: PropTypes.any.isRequired,
  };

  const statusColors = {
    open: "bg-green-500",
    assigned: "bg-blue-500",
    inprogress: "bg-yellow-500",
    pending: "bg-orange-500",
    closed: "bg-gray-500",
    reopened: "bg-purple-500",
  };

  const formatTimestamp = (timestamp) =>
    new Date(timestamp).toLocaleString();

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
      {tickets.map((ticket) => (
        <div
          key={ticket._id}
          className="
            rounded-2xl 
            shadow-lg 
            border border-gray-200
            bg-white/80 backdrop-blur-xl
            hover:shadow-2xl hover:scale-[1.01]
            transition-all duration-200 
            p-6 relative
          "
        >
          <div className="flex justify-between items-start">
            <span className="px-3 py-1 rounded-lg text-sm font-semibold bg-[#b99653]/10 text-[#8c6f3d]">
              {ticket.ticketType}
            </span>

            <p className="text-gray-500 text-sm font-medium">
              {formatTimestamp(ticket.createdDate)}
            </p>
          </div>

          <p className="text-gray-900 font-semibold text-lg mt-3">
            {ticket.title}
          </p>

          <p className="text-gray-500 text-sm mt-1 line-clamp-2 min-h-[40px]">
            {ticket.description}
          </p>

          <div className="flex justify-between items-center mt-4">
            <p className="text-sm text-gray-600 flex gap-1">
              Assigned to:
              <span className="font-semibold text-gray-900">
                {ticket.assignmentHistory[0]?.assignedTo.AdminName ||
                  "Unassigned"}
              </span>
            </p>

            <span
              className={`
                text-white text-xs font-semibold rounded-full 
                px-3 py-1 capitalize
                ${statusColors[ticket.status] || "bg-gray-500"}
              `}
            >
              {ticket.status}
            </span>
          </div>

          <div className="mt-5">
            <Link to={`/Dashboard/SingleTicket/${ticket._id}`}>
              <button
                className="
                  bg-gradient-to-r from-[#b99653] to-[#d4af37]
                  text-white font-bold text-sm
                  px-4 py-2 rounded-xl
                  hover:shadow-lg hover:scale-[1.03]
                  transition-all
                "
              >
                View
              </button>
            </Link>
          </div>
        </div>
      ))}
    </div>
  );
}

export default TicketsGrid;
